export const navLinks = [
    { to: "/", label: "Home" },
    { to: "/platform", label: "Platform" },
    { to: "/about", label: "About" },
    { to: "/blogs", label: "Blogs" },
    { to: "/contact", label: "Contact" },
];
